import EventActionProto from "../event-action-proto";
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "../../model2/project-collection/events";

export default class EventPortfolioReset extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
    }

    process() {
        gd.session.projectCollections.resetFromJson(this.data)
        gd.bus.triggerEvent(EVENT_BUS_SESSION_PORTFOLIO_CHANGED)
    }
}
